import axios from "axios";

export function forgottenPasswordAPI(action) {
  const email = action.email;

  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND}/forgottenpassword`,
        { email: email },
        metaData
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}

export function forgottenPasswordResetAPI(action) {
  const email = action.email;
  const code = action.code;
  const newPassword = action.password;
  const securityAnswer = action.securityAnswer;

  const metaData = {
    withCredentials: true,
  };

  return new Promise((resolve) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND}/changepassword/code`,
        {
          email: email,
          code: code,
          newPassword: newPassword,
          securityAnswer: securityAnswer,
        },
        metaData
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}
